import React, { useState } from 'react';
import { Form, Badge, InputGroup, Button } from 'react-bootstrap';
import { FaPlus, FaTimes, FaTools } from 'react-icons/fa';
import styled from 'styled-components';

const TagWrapper = styled.div`
 display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 8px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    min-height: 38px;
    align-items: center;
`;

const TagChip = styled(Badge)`
  background: #2473db !important; /* Brand Blue */
    color: #ffffff !important;
    border: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 11px;
    font-weight: 600;
    padding: 5px 10px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 4px;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    &:hover {
        background: #1d5cb3 !important;
        transform: translateY(-1px);
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }

    .remove-icon {
        cursor: pointer;
        font-size: 14px;
        opacity: 0.7;
        &:hover {
            opacity: 1;
            color: #ff9999;
        }
    }
`;

const RefurbTagInput = ({ tags = [], setTags }) => {
    const [input, setInput] = useState("");

    const handleAdd = () => {
        if (input.trim() && !tags.includes(input.trim())) {
            setTags([...tags, input.trim()]);
            setInput("");
        }
    };

    const handleRemove = (tagToRemove) => {
        setTags(tags.filter(t => t !== tagToRemove));
    };

    return (
        <div className="refurb-tag-input mt-2">
            <InputGroup size="sm">
                <InputGroup.Text className="bg-white"><FaTools size={10} /></InputGroup.Text>
                <Form.Control
                    placeholder="Add Refurb Tag (e.g. Battery: A++)"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAdd())}
                    className="x-small"
                />
                <Button variant="outline-dark" onClick={handleAdd} size="sm"><FaPlus size={10} /></Button>
            </InputGroup>
            <TagWrapper>
                {tags.map((tag, i) => (
                    <TagChip key={i}>
                        {tag} <FaTimes onClick={() => handleRemove(tag)} style={{ cursor: 'pointer' }} />
                    </TagChip>
                ))}
            </TagWrapper>
        </div>
    );
};

export default RefurbTagInput;
